import React, { Component } from 'react';
import './index.css';

class Footers extends Component {
    render() {
        const {hrefL,hrefR,textL,textR,tag}=this.props
        return (
            <div className="footer_page">
                <div className="footer_con flex_row" style={{display:tag=="home"?"none":""}}>
                    <div className="footer_left">
                        <a className='flex_row' href={hrefL}>
                            <span className="prve"></span>
                            <span className="text">{textL}</span>
                        </a>
                    </div>
                    <div className="footer_center hidden-xs">
                        <div>Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights reserved.</div>
                        <a href="about/disclaimerr" target="new">Disclaimer</a> | <a href="about/importantinformation" target="new">Important Information</a> | <a href="https://www.macquarie.com/sg/about/disclosures/privacy-and-cookies" target="new">Macquarie Privacy Statement</a> | <a href="https://www.warrants.com.sg/about/termsofuse" target="new">Terms Of Use</a>
                    </div>
                    <div className="footer_right">
                        <a href={hrefR} className='flex_row' style={{display:hrefR?"":"none"}}>
                            <span className="text">{textR}</span>
                            <span className="next"></span>
                        </a>
                    </div>
                </div>
                <div className="footer_center footer_center_home flex_column" style={{display:tag=="home"?"":"none"}}>
                    <div>Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights reserved.</div>
                    <div>
                        <a href="about/disclaimerr" target="new">Disclaimer</a> | <a href="about/importantinformation" target="new">Important Information</a> | <a href="https://www.macquarie.com/sg/about/disclosures/privacy-and-cookies" target="new">Macquarie Privacy Statement</a> | <a href="https://www.warrants.com.sg/about/termsofuse" target="new">Terms Of Use</a>
                    </div>
                </div>
            </div>
        );
    }
}
export default Footers;